import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { DamageReason } from "../item-damage-reason.entity";
import { DamageReasonDto } from "./item-damage-reasons.dto";

export class DamageReasonAdapter {
    convertDtoToEntity(dtoObj: DamageReasonDto,  isUpdate: boolean = false ): DamageReason {
        try {
            const entityObj = new DamageReason();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.damageReason = dtoObj.damageReason;
            entityObj.remarks = dtoObj.remarks;
            if (dtoObj.damageReasonId) {
                entityObj.damageReasonId = dtoObj.damageReasonId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: DamageReason): DamageReasonDto {
        const foodTypeDetailsDTO= new DamageReasonDto;
        foodTypeDetailsDTO.damageReasonId = employeeObject.damageReasonId;
        foodTypeDetailsDTO.damageReason = employeeObject.damageReason;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}